import React from 'react';
import { CheckIcon } from 'lucide-react';
export const ProgressBar = ({
  currentStep,
  totalSteps,
  completedSteps = []
}) => {
  const progress = currentStep / totalSteps * 100;
  return <div className="w-full" data-id="element-479">
      {/* Mobile Progress Bar - Only visible on mobile */}
      <div className="sm:hidden" data-id="element-480">
        <div className="h-1 w-full bg-gray-200 overflow-hidden" data-id="element-481">
          <div className="h-full bg-[#FCCA86] transition-all duration-500 ease-out" style={{
          width: `${progress}%`
        }} data-id="element-482"></div>
        </div>
      </div>
    </div>;
};